module.exports = __webpack_public_path__ + "img/pic6.9627fad.webp";